import { myInfoSWRKey } from '@api/hooks/auth/useMyInfo';
import { NOT_APPLICABLE } from '@constants/segment';
import segmentStorage from '@events/segmentStorage';
import camelcaseKeys from 'camelcase-keys';

const setUserDetailsBeforeEvent = (rawMeData, updateSWRCache) => {
  if (!rawMeData) return;

  const uid = rawMeData.uid || NOT_APPLICABLE;
  const learner_uid = uid;
  const username = rawMeData.username || NOT_APPLICABLE;
  const state = rawMeData.state || NOT_APPLICABLE;
  const userId = rawMeData.user_id || null;
  const isEmailVerified = rawMeData.is_email_verified || false;
  const phoneVerified = rawMeData.is_phone_verified || false;
  const isInvited = rawMeData.is_invited || false;

  const existingSegmentData = segmentStorage.getItem('segmentData');
  const segmentUserAlreadyIdentified = segmentStorage.getItem(
    'segmentUserIdentified',
    false
  );
  if (
    !segmentUserAlreadyIdentified &&
    existingSegmentData.learner_uid === NOT_APPLICABLE
  ) {
    // Only set data in case it's not already present.
    updateSWRCache(myInfoSWRKey, camelcaseKeys(rawMeData, { deep: true }));
    segmentStorage.setItem('segmentData', {
      ...segmentStorage.getItem('segmentData'),
      learner_uid,
      uid,
      username,
      state,
      user_id: userId,
      loginStatus: true,
      is_verified: (isEmailVerified && phoneVerified) ?? false,
      is_invited: isInvited
    });
    // eslint-disable-next-line no-console
    console.warn(
      'User details not set in segment storage yet, set manually before event'
    );
  }
};

export default setUserDetailsBeforeEvent;
